export interface DocumentItem {
  id: string | null;
  name: string | null;
  lastModified: Date | null;
  owner: string | null;
  url: string | null;
}

export class DocumentFile implements DocumentItem {
  id: string | null;
  name: string | null;
  lastModified: Date | null;
  owner: string | null;
  url: string | null;
  mimeType: string | null;

  constructor({ id, name, lastModified, owner, url, mimeType }: DocumentFile) {
    this.id = id;
    this.name = name;
    this.lastModified = lastModified;
    this.owner = owner;
    this.url = url;
    this.mimeType = mimeType;
  }
}
